import type { App } from 'vue'
import Vue3Marquee from 'vue3-marquee'
import { installAnalytics } from './analytics'
import { installAOS } from './aos'
import { installElementPlus } from './element-plus'
import { installHead } from './head'
import { i18n } from './i18n'
import { iconify } from './iconify'
import { pinia } from './pinia'
import { router } from './router'
import { initSentry } from './sentry'
import { VueQueryPlugin, vueQueryPluginOptions } from './tanStackQuery'
import { installToast } from './toast'

export function setupProviders(app: App) {
  // Initialize Sentry early to catch all errors
  initSentry(app)

  app.use(pinia)
  app.use(router)
  app.use(i18n)
  installHead(app)
  app.use(VueQueryPlugin, vueQueryPluginOptions)
  app.use(iconify)
  app.use(Vue3Marquee)
  installAOS()
  installToast(app)
  installElementPlus(app)
  // Analytics pipeline — must come AFTER app.use(pinia) so the consent
  // store resolves, and AFTER Sentry so errors during setup are captured.
  installAnalytics()
}
